<template>
    <div class="d-flex flex-column align-items-center justify-content-center h-100">
      <img alt="Logo" src="/media/logos/hc-pink.png" width="500" />
      <br /><br /><br />
      <div class="">
        <span class="spinner-border text-primary" role="status"></span>
        <span class="text-muted fs-3 fw-bold mt-5"
          >&nbsp;&nbsp;&nbsp;Hacking {{ t(`${currentLanguage}.user_progress.in_progress`) }}...</span
        >
      </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

const store = useStore();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const { t } = useI18n();

</script>